<template>
  <div class="pt-10 pb-8 bg-white min-h-screen">
    <Sidebar></Sidebar>
    <Header>{{$t('all.kids_profile')}}</Header>

    <div class="bg-pink p-16 pt-8 px-10 text-center block relative">

      <div class="container mx-auto">
        <div class="flex items-baseline">
          <div class="relative flex-1">
            <div
              class="w-10 h-10 absolute rounded-full z-1 -mt-12 -ml-12"
              :class="'bg-' + evalutateMinor()"
              style="top:50%; left:50%;"
            >
            </div>
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative"
              :class="'border-' + evalutateMinor()"
              src="/img/user.png"
            >
          </div>
        </div>

        <h3 class="pt-5 text-pink-dark">{{ minor.name }} {{ minor.surname }}</h3>
        <p class="mt-4 text-xs text-white">
          {{$t('all.class')}} {{ getClassName($route) }}
        </p>
      </div>
    </div>
    <div class="pb-10 px-4">
      <div class="container mx-auto px-4">
        <!-- Info -->
        <div class="px-4 pt-20 pb-20">
          <div class="pb-2">
            <h4 class="pb-2 text-sm text-blue-dark">{{$t('all.family_contacts')}}</h4>
            <div class="pt-2">
              <div
                class="block"
                v-for="genitore in genitori"
                :key="genitore.id"
              >
                <div class="flex py-5 border-b-2 border-dashed border-pink">
                  <div class="flex-1">
                    <h4 class="text-sm pb-1 text-red">{{ genitore.name }} {{ genitore.surname }}</h4>
                  </div>
                  <div class="flex-wrap text-right">
                    <p class="text-xs pt-2 pb-5">
                      <a
                        :href="`tel:${genitore.mobile}`"
                        target="_blank"
                        class="text-grey no-underline border py-1 px-2 rounded-full border-yellow"
                      >
                        {{ genitore.mobile }}
                      </a>
                      <br>
                    </p>
                    <p class="text-xs">
                      <a
                        :href="`mailto:${genitore.email}`"
                        class="text-grey no-underline border py-1 px-3 rounded-full border-yellow"
                      >
                        {{$t('all.common_email')}}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  async created() {
    const { id } = this;
    const role = authService.getRole();
    await this.getMinor({ id, role });
  },
  computed: {
    ...mapGetters({
      getClassName: 'users/getClassName',
      minor: 'users/minor',
      genitori: 'users/genitori',
    }),
  },
  methods: {
    ...mapActions('users', ['getMinor']),
    evalutateMinor() {
      if (!this.minor.status) {
        return '';
      }
      if (this.minor.status === 'left') {
        return 'grey-darkest';
      }
      if (
        this.minor.status === 'warning' &&
        this.minor.status_description === 'minor_warning'
      ) {
        return 'orange';
      }
      if (this.minor.status === 'ok') {
        if (this.minor.status_description === 'minor_not_yet_expected') {
          return 'blue';
        }
        if (this.minor.status_description === 'qr_arrived') {
          return 'blinkingBlue';
        }
        if (
          this.minor.status_description === 'emergency_call_answered' ||
          this.minor.status_description === 'absence_expected' ||
          this.minor.status_description === 'minor_absent_by_teacher'
        ) {
          return 'purple';
        }
        if (
          this.minor.status_description === 'still_closed' ||
          this.minor.status_description === 'day_of_closure'
        ) {
          return 'grey-light';
        }
        return 'green';
      }
      if (this.minor.status === 'danger') {
        if (
          this.minor.status_description === 'minor_max_danger' ||
          this.minor.status_description === 'no_tutor_answered'
        ) {
          return 'flipDanger';
        }
        return 'red';
      }
      return '';
    },
  },
};
</script>
